const initialState = {
  cart: { items: [], shipment_address: undefined }
}

const cartReducer = (state = initialState, action) => {
  switch(action.type){
    case 'SAVE_CART':
      return {
        ...state,
        cart: action.payload.cart
      }
    case 'SAVE_CART_CONTACTS':
      return {
        ...state,
        cart: {
          ...state.cart,
          contacts: action.payload
        }
      }
    default:
      return state;
  }
}
export default cartReducer;